export default {

    getLegalStatusContainerTransport: {
        method: 'get',
        url: '/dashboard/vehicle-fleet-management/legal-status-container-transport'
    },
    getDataLegalStatusContainerTransport: {
        method: 'get',
        url: '/dashboard/vehicle-fleet-management/data-legal-status-container-transport?type=TYPE'
    },

    getNearingExpirationDocumentContract: {
        method: 'get',
        url: '/dashboard/vehicle-fleet-management/document-nearing-expiration'
    },
    getDataNearingExpirationDocumentContract: {
        method: 'get',
        url: '/dashboard/vehicle-fleet-management/data-document-nearing-expiration?type=TYPE'
    },

    getNearingExpirationRemmoc: {
        method: 'get',
        url: '/dashboard/vehicle-fleet-management/nearing-expiration-remooc'
    },
    getDataNearingExpirationRemmoc: {
        method: 'get',
        url: '/dashboard/vehicle-fleet-management/data-nearing-expiration-remooc?type=TYPE'
    },

    getNearingExpirationVehicle: {
        method: 'get',
        url: '/dashboard/vehicle-fleet-management/nearing-expiration-vehicle'
    },

    getDataNearingExpirationVehicle: {
        method: 'get',
        url: '/dashboard/vehicle-fleet-management/data-nearing-expiration-vehicle?type=TYPE'
    },

    getVehicleTransportReadyStatus: {
        method: 'get',
        url: '/dashboard/vehicle-fleet-management/vehicle-transport-ready-status'
    },
    getDataVehicleTransportReadyStatus: {
        method: 'get',
        url: '/dashboard/vehicle-fleet-management/data-vehicle-transport-ready-status?status=STATUS'
    }
}
